var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpFilterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44153 12.0663H5.65327C3.63764 12.0663 2.63011 12.0663 2.00378 11.4281C1.37744 10.79 1.37744 9.76278 1.37744 7.70892C1.37744 5.65506 1.37744 4.62785 2.00378 3.9897C2.63011 3.35156 3.63764 3.35156 5.65327 3.35156H7.79147C9.8071 3.35156 10.8152 3.35156 11.4415 3.9897C11.9234 4.48054 12.0341 5.20189 12.06 6.44388",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24912 3.34284L9.1929 3.16854C8.91515 2.3027 8.77572 1.86977 8.44456 1.62239C8.11283 1.375 7.67316 1.375 6.79326 1.375H6.64483C5.76492 1.375 5.32469 1.375 4.99353 1.62239C4.66218 1.8695 4.52324 2.30173 4.24556 3.16565L4.24463 3.16854L4.18896 3.34284M7.5624 10.0897C7.5624 10.422 7.62784 10.751 7.75499 11.0579C7.88214 11.3649 8.06851 11.6438 8.30344 11.8787C8.53838 12.1137 8.8173 12.3001 9.12426 12.4272C9.43122 12.5543 9.76023 12.6198 10.0925 12.6198C10.4247 12.6198 10.7537 12.5543 11.0607 12.4272C11.3677 12.3001 11.6466 12.1137 11.8815 11.8787C12.1165 11.6438 12.3028 11.3649 12.43 11.0579C12.5571 10.751 12.6226 10.422 12.6226 10.0897C12.6226 9.41869 12.356 8.77516 11.8815 8.30068C11.407 7.8262 10.7635 7.55964 10.0925 7.55964C9.42146 7.55964 8.77793 7.8262 8.30344 8.30068C7.82896 8.77516 7.5624 9.41869 7.5624 10.0897Z",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8513 10.8492L10.0923 10.3432V9.07812",
    strokeWidth: 0.963839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpFilterLight);
export default __webpack_public_path__ + "static/media/exp-filter-light.3f2247e77fe4219abc4bd22830170568.svg";
export { ForwardRef as ReactComponent };